export default __webpack_public_path__ + "static/seal-4e08549610d4fa578c14f4792acf5ad8.svg";